<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Função</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in users" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-user-edit', params: { userId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-3">{{ row.email }}</td>
        <td class="td-2">{{ (row.settings.type.name) ? row.settings.type.name : 'Administrador' }}</td>
        <td class="td-2">
          <user-buttons :user="row"></user-buttons>
        </td>
      </tr>
      <tr v-if="users.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum usuário cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de usuário"
      message="Tem certeza que deseja excluir esse usuário?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import UserButtons from './UserButtons.vue';
import UserDelete from './UserDelete';
import { _DELETE_USER_ } from './UserModel';

export default {
  name: 'user-table',
  mixins: [UserDelete],
  components: {
    UserButtons,
    ConfirmationModal,
  },
  props: {
    users: {
      type: Array,
    },
  },
  data() {
    return {
      selectUser: null,
    };
  },
  mounted() {
    this._onDeleteUser = user => { this.selectUser = user.id; };
    Events.$on(_DELETE_USER_, this._onDeleteUser);
  },
  beforeDestroy() {
    Events.$off(_DELETE_USER_, this._onDeleteUser);
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
